function NumberOrNull(obj: any): number | null {
    if (!obj) return null;
    const num = Number(obj);
    return isNaN(num) ? null : num;
}

/**
 * возвращает null вместо объекта с id-шником 0
 * */
function simpleDtoOrNull(id: number): { Id: number } | null {
    return id && !isNaN(id) ? { Id: id } : null;
}

function getMaxOfArray(numArray: number[]): number {
    return Math.max.apply(null, numArray);
}

function arrayContainsArray(superset: any[], subset: any[]): boolean {
    if (!subset.length || superset.length < subset.length) return false;

    for (let i = 0; i < subset.length; i++) {
        if (superset.indexOf(subset[i]) === -1) return false;
    }

    return true;
}

function lockPage(lock: boolean) {
    kendo.ui.progress($(document.body), lock);
    const floatingButtons = $('.floatingButtons');

    if (floatingButtons) {
        if (lock) {
            floatingButtons.css('pointer-events', 'none');
            floatingButtons.css('opacity', '0.7');
        }
        else {
            floatingButtons.css('pointer-events', '');
            floatingButtons.css('opacity', '');
        }
    }
}

function audioBlock(id: number, record: string) {
    $('#audioFileDiv').append(`
        <audio id='audio${id}' style="position: relative; top: 11px;" preload='metadata' controls>
            <source src='/Audio/PlayFile?filePath=${record}#' type='audio/mpeg'>
        </audio>
        <select id='select${id}' class='speed' onchange='speed_onChange?.(this)'>
            <option>1x</option>
            <option>1.25x</option>
            <option>1.5x</option>
            <option>1.75x</option>
            <option>2x</option>
            <option>3x</option>
            <option>4x</option>
        </select>
    `);
}

function PhoneOrContact(obj: string): string | number | null {
    if (!obj) return null;
    let cleanedContact: string = obj.replace(/[^\wа-яА-Я]/gi, '');
    if (cleanedContact.length === 11 && cleanedContact.startsWith('8')) {
        cleanedContact = cleanedContact.replace(/^8/, '7');
    }
    const phoneRaw: number = Number(cleanedContact);
    return isNaN(phoneRaw) ? obj : phoneRaw;
}

/**
 * функция добавляет иконки к номерам телефонов, игнорируя емейлы
 * */
function addPhoneIcons(contactInfo: string, isCenter: boolean = true): string {
    if (!contactInfo) return '';

    let result: string = '';
    const containerClasses = `contact-cell${isCenter ? '' : ' contact-cell_left'}`;
    const contacts: string[] = contactInfo
        .split(/(<br>|<br\/>|<\/br>|\n)/)
        .map(item => item.replace(/<\/?br(\/)?>/g, ''))
        .filter(item => item);

    contacts.forEach((contact, index) => {
        switch (true) {
            case /\d{11,12}$/.test(contact): {
                const formattedPhone: string = contact.length === 11
                    ? `+${contact.slice(0, 1)} ${contact.slice(1, 4)} ${contact.slice(4, 7)}-${contact.slice(7, 9)}-${contact.slice(9, 11)}`
                    : `+${contact.slice(0, 3)} ${contact.slice(3, 5)} ${contact.slice(5, 8)}-${contact.slice(8, 10)}-${contact.slice(10, 12)}`;

                result += `
                    <div class="${containerClasses}">
                        ${formattedPhone}
                        <a class="icon-container" onclick="makeCall('${contact}', this)">
                            <img class="callLink" src="/img/Phone-info.svg" alt="phone">
                        </a>
                        <a href="https://wa.me/${contact}" target="_blank">
                            <img class="icon_whatsapp" src="/img/WhatsApp.svg" alt="whatsapp">
                        </a>
                    </div>
                `;
                break;
            }
            case /^\d{3,}$/.test(contact): {
                result += `
                    <div class="${containerClasses}">
                        ${contact}
                        <a class="icon-container" onclick="makeCall('${contact}', this)">
                            <img class="callLink" src="/img/Phone-info.svg" alt="phone">
                        </a>
                    </div>
                `;
                break;
            }
            case /@/.test(contact): {
                result += `
                    <div class="${containerClasses}">
                        <a href="mailto:${contact}">${contact}</a>
                    </div>
                `;
                break;
            }
            default:
                result += contact + (index < contacts.length - 1 ? '<br>' : '');
                break;
        }
    });

    return result;
}

function setProperIframeResize() {
    const body = $('body');

    body.on('mousedown', ({ target }) => {
        if (target.closest('.k-resize-handle') || target.closest('.k-window-titlebar')) {
            body.addClass('iframe-blocked');
            body.on('mouseup', cancelEffect);
        }
    });

    function cancelEffect() {
        body.removeClass('iframe-blocked');
        body.off('mouseup', cancelEffect);
    }
}

function floatingButtonsAutoTop() {
    const floatingButtonsTop = ($('.k-menu-horizontal').height() ?? 0) + 10;
    $('.floatingButtons').attr('style', `top: ${floatingButtonsTop}px`);
}

function changeLabel(labelname: string, text: string) {
    let label = $(`[for='${labelname}']`);

    if (!label.length) {
        label = $(`#${labelname}`);
    }

    if (label) {
        if (text) {
            if (label.text() !== text.toString()) {
                label.text(text);
                label.trigger('change');
            }
        }
        else if (label.text()) {
            label.text('');
            label.trigger('change');
        }
    }
}

function makeCall(number: string, self: HTMLLinkElement | null = null) {
    const url = `/Commutation/MakeCall?number=${number}`;

    if (!self || !$(self).attr('disabled')) {
        if (self) {
            $(self).attr('disabled', 'disabled');
        }

        window.ajaxGet(url, null, (response) => {
            if (self) {
                $(self).removeAttr('disabled');
            }

            if (!response.Data) {
                window.swal.fire('Внимание!', response.Message, 'warning');
            }
        });
    }
}

function btCreateFromObject_onClick() {
    if (window.pageYOffset > 0) {
        $(window).scrollTop(0);
        setTimeout(openCmCreateFromObject, 500);
    }
    else {
        openCmCreateFromObject();
    }
}

function openCmCreateFromObject() {
    $('#btCreateFromObject').tooltip('hide');
    $('#cmCreateFromObject').data('kendoContextMenu')?.open(0);
}

function getAllClientsByContact(url: string, contactId: string) {
    const data = { contactId };
    const clientsDiv = $('#clientsDiv');

    window.ajaxGet(url, data, (response) => {
        clientsDiv.html(!response.Message ? response.Data : 'По данному контакту не найдено контрагентов');

        if (clientsDiv.text() === '') {
            clientsDiv.text('Найден контрагент без имени');
        }
        return response;
    });
}

function placeholder(element: JQuery<HTMLElement>) {
    return element.clone().addClass('k-state-hover').css('opacity', 0.65);
}

function btResetFilters_onClick() {
    location.href = location.href.split('?')[0];
}

function substractCommonHeight(height: number) {
    const body = $('body');
    const kReset = $('.k-reset.k-tabstrip-items');
    const kStateActive = $('.k-content.k-state-active');

    if (body.length === 1) {
        height -= parseFloat(body.css('padding-top'));
        height -= parseFloat(body.css('padding-bottom'));
        height -= parseFloat(body.css('margin-top'));
        height -= parseFloat(body.css('margin-bottom'));
    }

    if (kReset.outerHeight(true)) {
        height -= kReset.outerHeight(true) ?? 0;
        height -= parseFloat(kReset.css('padding-top'));
    }

    if (kStateActive.length === 1) {
        height -= parseFloat(kStateActive.css('padding-top'));
        height -= parseFloat(kStateActive.css('padding-bottom'));
        height -= parseFloat(kStateActive.css('margin-bottom'));
    }

    height = substractMultipleHeight(height, $('.k-grid-header'));
    height = substractMultipleHeight(height, $('.k-grouping-header'));
    height = substractMultipleHeight(height, $('.k-pager-wrap'));
    height = substractMultipleHeight(height, $('.k-grid-footer'));
    height = subtractHeight(height, $('.startSaldo'));
    height = subtractHeight(height, $('.finishSaldo'));
    height = subtractHeight(height, $('.info'));
    height = subtractHeight(height, $('.title'));
    height = subtractHeight(height, $('.title2'));
    height = subtractHeight(height, $('.filters'));
    height = subtractHeight(height, $('.floatingButtons'));
    height = subtractHeight(height, $('.button-filters'));
    height = subtractHeight(height, $('.k-menu-horizontal'));
    height = subtractHeight(height, $('.k-fieldselector'));
    height = subtractHeight(height, $('#test-server-label'));

    return height;
}

function subtractHeight(height: number, element: JQuery) {
    if (element && element.length === 1 && element.css('display') !== 'none') {
        height -= element.outerHeight(true) ?? 0;
    }

    return height;
}

function substractMultipleHeight(height: number, element: JQuery) {
    if (!element) return height;

    if (element.length > 1) {
        for (let i = 0; i < element.length; i++) {
            height -= element[i].offsetHeight;
        }
    }
    else {
        height = subtractHeight(height, element);
    }

    return height;
}

function getYandexMapUrl(longitude: number, latitude: number) {
    return `https://maps.yandex.ru/?whatshere[point]=${longitude},${latitude}&whatshere[zoom]=17`;
}

/**
 * Обертка для вызова динамической функции из partial _AuditHistory,
 * поиск по названию: updateHistoryLabel@(suffix)()
 * */
function updateHistoryLabel(suffix: string): void {
    window[`updateHistoryLabel${suffix}`]();
}

function isMacOS() {
    return navigator.userAgent.indexOf('Mac OS') !== -1;
}

function normalizeHexColor(color?: string) {
    if (!color) {
        return '';
    }
    return color.startsWith('#') ? color : `#${color}`;
}

function setCellBgColor(data: Record<string, string>) {
    const color = data[this.field];

    if (color) {
        const colorBg = normalizeHexColor(color);
        const colorText = window.invertColor(colorBg, true);
        return {
            style: `background-color: ${colorBg}; color: ${colorText};`
        };
    }

    return {};
}

window.setProperIframeResize = setProperIframeResize;
window.substractCommonHeight = substractCommonHeight;
window.lockPage = lockPage;
window.addPhoneIcons = addPhoneIcons;
window.audioBlock = audioBlock;
window.arrayContainsArray = arrayContainsArray;
window.btCreateFromObject_onClick = btCreateFromObject_onClick;
window.changeLabel = changeLabel;
window.btResetFilters_onClick = btResetFilters_onClick;
window.floatingButtonsAutoTop = floatingButtonsAutoTop;
window.getAllClientsByContact = getAllClientsByContact;
window.makeCall = makeCall;
window.getMaxOfArray = getMaxOfArray;
window.getYandexMapUrl = getYandexMapUrl;
window.NumberOrNull = NumberOrNull;
window.openCmCreateFromObject = openCmCreateFromObject;
window.placeholder = placeholder;
window.PhoneOrContact = PhoneOrContact;
window.substractMultipleHeight = substractMultipleHeight;
window.subtractHeight = subtractHeight;
window.simpleDtoOrNull = simpleDtoOrNull;
window.updateHistoryLabel = updateHistoryLabel;
window.isMacOS = isMacOS;
window.setCellBgColor = setCellBgColor;
window.normalizeHexColor = normalizeHexColor;